// useFetchPaymentDetails.js
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useToasts } from 'react-toast-notifications';
import { fetchAsyncGetPaymentDetail } from 'redux/paymentSlice';

const useFetchPaymentDetails = (expenseId, paymentId) => {
  const dispatch = useDispatch();
  const {addToast} = useToasts();
  const [paymentData, setPaymentData] = useState(null);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);

  const fetchPaymentDetails = () => {
    if (expenseId && paymentId) {
        setIsPaymentLoading(true);
      dispatch(fetchAsyncGetPaymentDetail({ expenseId, paymentId }))
        .then((res) => {
          if (res?.payload) {
            setPaymentData(res.payload.payment);
          }
        })
        .catch((err) => {
          addToast(`${err?.message}`, { appearance: "error" });
        })
        .finally(() => {
            setIsPaymentLoading(false);
        });
    }
  };

  useEffect(() => {
    fetchPaymentDetails();
  }, [expenseId, paymentId]);

  return { paymentData, isPaymentLoading, refetch: fetchPaymentDetails };
};

export default useFetchPaymentDetails;
